<template>
  <div class="header">
    <div>
      <label :for="column"> {{ $t("supplier." + column) }}</label>
      <i
        @click="changeOrder"
        class="fa"
        :class="{
          'fa-arrow-up': isAscending,
          'fa-arrow-down': isAscending === false,
          'fa-minus': isAscending === null,
        }"
      ></i>
    </div>
    <select
      class="header-select"
      :id="column"
      autocomplete="off"
      v-model="value"
      required
    >
      <option v-for="(o, key) in options" :key="key" :value="o.value">
        {{ $t(o.name) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: [
    "column",
    "filterVal",
    "valid",
    "isAscending",
    "validator",
    "options",
  ],
  methods: {
    changeOrder: function () {
      let orderBy = {
        column: this.column,
        isAscending: !this.isAscending,
      };
      this.$emit("updateOrderBy", orderBy);
    },
  },
  computed: {
    value: {
      get: function () {
        return this.filterVal;
      },
      set: function (value) {
        this.$emit("updateFilter", value);
      },
    },
  },
};
</script>
<style scoped>
select::-ms-expand {
  display: none;
}
select {
  border-bottom-color: rgba(0, 0, 0, 0.25);
  transition: 0.3s ease border;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.fa-minus,
.fa-arrow-up,
.fa-arrow-down {
  float: right;
}
.header {
  position: relative;
}
.header label {
  float: left;
}
.header .fa {
  cursor: pointer;
}
.header-select:valid + label,
.calendar-open,
.header:focus-within > label {
  transform: translateY(-15px);
  font-size: 12px;
}
.header > select {
  outline: none;
  border-radius: 0;
  border-width: 0 0 1px;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  transition: 0.3s ease border;
  padding-right: 0.1em;
  min-width: 60px;
}

.header > select:focus {
  border-bottom: 1px solid;
}
</style>
